module.exports = __webpack_public_path__ + "img/icon-language.a7ed7ee3.svg";